import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ContextMenuCopyLinkIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        className="Icon context-menu-copy-link"
        {...props}
    >
        <g fill="#323B4A">
            <path d="M12.81 3.732a5.272 5.272 0 0 1 7.395.065 5.286 5.286 0 0 1 .055 7.41l-2.715 2.718a5.273 5.273 0 0 1-7.956-.57.75.75 0 0 1 1.202-.898 3.774 3.774 0 0 0 5.693.408l2.706-2.709a3.783 3.783 0 0 0-.046-5.3 3.77 3.77 0 0 0-5.284-.053l-1.557 1.55a.75.75 0 1 1-1.058-1.064l1.564-1.557z" />
            <path d="m10.294 8.528.27.013a5.274 5.274 0 0 1 3.847 2.104.75.75 0 1 1-1.202.898 3.774 3.774 0 0 0-5.693-.408L4.81 13.844a3.783 3.783 0 0 0 .046 5.3 3.77 3.77 0 0 0 5.283.054l1.548-1.549a.75.75 0 1 1 1.06 1.06l-1.556 1.559a5.272 5.272 0 0 1-7.396-.065 5.286 5.286 0 0 1-.055-7.41l2.715-2.718a5.273 5.273 0 0 1 4.108-1.534l-.269-.013z" />
        </g>
    </svg>
);
const Memo = memo(ContextMenuCopyLinkIcon);
export default Memo;
